import { DEFAULT_CLIENTS_CATEGORY_ORDER, normalizeCategoryOrder } from '@/entities/clients-categories';
import type { ClientsListType } from '@/entities/clients-filter.entity';

export interface RepairStoredOrderResult {
	order: ClientsListType[];
	needsWrite: boolean;
}

export function repairStoredOrder(raw: string | null): RepairStoredOrderResult {
	if (!raw) {
		return { order: [...DEFAULT_CLIENTS_CATEGORY_ORDER], needsWrite: false };
	}

	try {
		const parsed: unknown = JSON.parse(raw);
		const normalized = normalizeCategoryOrder(parsed);
		const needsWrite = !Array.isArray(parsed) || JSON.stringify(normalized) !== JSON.stringify(parsed);
		return { order: normalized, needsWrite };
	} catch {
		return { order: [...DEFAULT_CLIENTS_CATEGORY_ORDER], needsWrite: true };
	}
}
